import { Phone } from "lucide-react";
import logoAsset from "@/assets/oz-waste-logo.webp.asset.json";
const logo = logoAsset.url;

const ServiceHeader = () => (
  <header className="bg-[#FDC00E] sticky top-0 z-50">
    <div className="container flex flex-nowrap items-center justify-between gap-4 py-3 whitespace-nowrap">
      <a href="/" className="shrink-0" aria-label="OZ WASTE CO. home">
        <img
          src={logo}
          alt="OZ WASTE CO. Logo"
          className="h-14 md:h-20 w-auto"
          width="288"
          height="192"
        />
      </a>
      <div className="flex flex-nowrap items-center gap-2 md:gap-3 shrink-0">
        <a
          href="tel:1800556654"
          data-call-source="service_header"
          aria-label="Call 1800 556 654"
          className="inline-flex items-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-3 md:px-4 py-2 font-bold text-sm rounded-full hover:bg-orange/10 hover:border-orange hover:text-orange-deep transition-colors whitespace-nowrap shrink-0"
        >
          <Phone className="w-4 h-4 shrink-0" />
          <span className="hidden lg:inline">1800 556 654</span>
        </a>
        <a
          href="/#quote"
          className="inline-flex bg-[#1a1a1a] text-white px-4 md:px-5 py-2 font-bold text-sm rounded-full hover:bg-orange transition-colors whitespace-nowrap shrink-0"
        >
          Get Free Quote
        </a>
      </div>
    </div>
  </header>
);

export default ServiceHeader;